import { supabase } from './supabase';

const FALLBACK_TYPES = [
  { id: 'SL', code: 'SL', label: 'Servicio y Mano de Obra', is_active: true, sort_order: 0 },
  { id: 'EQ', code: 'EQ', label: 'Equipos',                 is_active: true, sort_order: 1 },
  { id: 'MA', code: 'MA', label: 'Materiales',              is_active: true, sort_order: 2 },
  { id: 'IN', code: 'IN', label: 'Instalación',             is_active: true, sort_order: 3 },
  { id: 'MT', code: 'MT', label: 'Mantenimiento',           is_active: true, sort_order: 4 },
  { id: 'RP', code: 'RP', label: 'Reparación',              is_active: true, sort_order: 5 },
];

export const getProjectTypes = async (includeInactive = false) => {
  try {
    let query = supabase
      .from('project_types')
      .select('*')
      .order('sort_order', { ascending: true })
      .order('label',      { ascending: true });

    if (!includeInactive) {
      query = query.eq('is_active', true);
    }

    const { data, error } = await query;
    if (error) throw error;
    return data?.length ? data : FALLBACK_TYPES;
  } catch {
    return FALLBACK_TYPES;
  }
};

export const createProjectType = async ({ code, label, sort_order = 99 }) => {
  const { data, error } = await supabase
    .from('project_types')
    .insert({ code: code.toUpperCase().trim(), label: label.trim(), sort_order, is_active: true })
    .select()
    .single();
  return { data, error };
};

export const updateProjectType = async (id, updates) => {
  const patch = { ...updates };
  if (patch.code) patch.code = patch.code.toUpperCase().trim();
  if (patch.label) patch.label = patch.label.trim();

  const { data, error } = await supabase
    .from('project_types')
    .update(patch)
    .eq('id', id)
    .select()
    .single();
  return { data, error };
};

export const deleteProjectType = async (id) => {
  const { error } = await supabase
    .from('project_types')
    .delete()
    .eq('id', id);
  return { error };
};
